//TODO: get proper type from ICartItemErrorType right now ItemQty is missing
export var ExtendedCartItemErrorType;
(function (ExtendedCartItemErrorType) {
    ExtendedCartItemErrorType["Undefined"] = "UNDEFINED";
    ExtendedCartItemErrorType["ItemQty"] = "ITEM_QTY";
    ExtendedCartItemErrorType["ItemIncrements"] = "ITEM_INCREMENTS";
    ExtendedCartItemErrorType["CartonLimit"] = "CARTONS_LIMIT";
    ExtendedCartItemErrorType["Ongoing"] = "ONGOING_SUBSCRIPTION";
})(ExtendedCartItemErrorType || (ExtendedCartItemErrorType = {}));
export const hasCartErrorCode = (errors, errorCode) => {
    for (const error of errors) {
        if (error.code === errorCode) {
            return true;
        }
    }
    return false;
};
export const filterItemsByErrorCode = (items, errorCode) => {
    return items.filter((item) => item.errors?.some((error) => error.code === errorCode));
};
//# sourceMappingURL=getCartErrors.js.map